module.exports = __webpack_public_path__ + "static/media/s_soccer.f21231c7.mp3";